export default __webpack_public_path__ + "static/media/part_4.d782a88f.svg";